/*
  AironiMenager — lecture des vidéos d'utilisation.
  Lecture muette en boucle quand la vidéo est visible, pause sinon ; le
  bouton haut-parleur active le son (et coupe celui des autres vidéos).
  Si l'utilisateur préfère moins d'animations, rien ne démarre seul :
  un appui sur la vidéo la lance.
*/
if (!customElements.get('am-video')) {
  const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const visibilite = new IntersectionObserver(
    (entrees) => {
      entrees.forEach((e) => {
        const video = e.target.querySelector('video');
        if (!video) return;
        if (e.isIntersecting && !reduit) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.5 }
  );

  customElements.define(
    'am-video',
    class extends HTMLElement {
      connectedCallback() {
        const video = this.querySelector('video');
        const bouton = this.querySelector('.am-videos__son');
        if (!video) return;
        video.muted = true;
        video.removeAttribute('controls');
        visibilite.observe(this);

        video.addEventListener('click', () => (video.paused ? video.play() : video.pause()));

        bouton?.addEventListener('click', () => {
          const activer = video.muted;
          document.querySelectorAll('am-video video').forEach((v) => {
            v.muted = true;
            v.closest('am-video')?.querySelector('.am-videos__son')?.setAttribute('aria-pressed', 'false');
          });
          video.muted = !activer;
          if (activer) video.play().catch(() => {});
          bouton.setAttribute('aria-pressed', String(activer));
          bouton.setAttribute('aria-label', activer ? 'Couper le son' : 'Activer le son');
        });
      }
    }
  );
}
